// ThreadView barrel 의 default 분기 결정 helper.
//
// barrel ([./index.tsx](./index.tsx)) 가 InnerViewer / IFrameViewer 양 클래스 default
// import 와 함께 본 helper 를 사용. 본 파일은 viewer 클래스 import 없이 독립 — 단위
// 테스트 가능 (DataManager / popups 등 transitive 의존을 회피).

// mobile WebView (iOS / Android native app) 감지. OfficeMail user-agent 검사는
// packages/email-thread-viewer/src/helper/mailview.ts 의 isOfficeMailApp() 와 동일 로직.
// host 측 인라인 — packages 의존 회피.
export function isMobileApp(): boolean {
  return window.navigator.userAgent.indexOf('OfficeMail') >= 0
}

// 양산 escape hatch — localStorage 의 `__forceIFrameViewer = 'true'` 가 설정되면
// InnerViewer 비활성. SSR / private mode 등의 localStorage 접근 실패는 try/catch 로
// false fallback (기본 동작 = InnerViewer 사용).
export function isForcedIFrameViewer(): boolean {
  try {
    return window.localStorage.getItem('__forceIFrameViewer') === 'true'
  } catch {
    return false
  }
}
